import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../axiosInterceptor";

const GATEWAY_BASE = process.env.REACT_APP_API_GATEWAY_BASE;
const ADMIN_BASE = process.env.REACT_APP_ADMIN_SERVICES_BASE || "";

export const getProductList = createAsyncThunk("getProductList", async () => {
  const { data } = await axios.get(
    `${GATEWAY_BASE + ADMIN_BASE}/getUserProducts/admin`
  );
  return data;
});

const getProductListSlice = createSlice({
  name: "getProductList",
  initialState: {
    loading: false,
    productList: null as any,
    error: false,
    success: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getProductList.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getProductList.fulfilled, (state, action) => {
      state.loading = false;
      state.success = true;
      state.productList = action.payload;
    });
    builder.addCase(getProductList.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
    });
  },
});

export default getProductListSlice.reducer;
